import { FC } from "react";
import { DeepMap, FieldError } from "@hookform/error-message/dist/types";
import { LessonTopicPageTextboxModel } from "../../../models/crud/lessontopicpagetextboxes/LessonTopicPageTextboxModel";
import { nameof } from "../../../utils/Helpers";
import { Checkbox } from "../Checkbox";

type Props = {
    errors: DeepMap<Record<string, any>, FieldError>;
    register: <HTMLCheckboxElement>(refOrValidationOptions: HTMLCheckboxElement) => void | ((ref: HTMLCheckboxElement | null) => void);
};

export const FieldLessonTopicPageTextboxIsImageSideBySide: FC<Props> = (props: Props) => {
    const { errors, register } = props;

    const nameIsImageSideBySide = nameof<LessonTopicPageTextboxModel>("IsImageSideBySide");

    return (
        <Checkbox
            name={nameIsImageSideBySide}
            label="Image side by side"
            register={register}
            errors={errors}
            helperText="This will show an associated image by the side of the snippet"
        />
    );
};
